module.exports = __webpack_public_path__ + "img/virtualis_slider_image.e3105fd3.png";